import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-body-2" }
const _hoisted_2 = { class: "text-caption text-medium-emphasis mb-1" }
const _hoisted_3 = { class: "error-log-body text-body-2" }
const _hoisted_4 = {
  key: 1,
  class: "pa-4 text-medium-emphasis"
}

import { computed } from 'vue';
import { Clipboard } from 'v-clipboard';
import {
  appNotifyState,
  openErrorLog,
  closeErrorLog,
  clearErrorLog,
  dismissErrorSnackbar,
} from '@/utils/appNotify';
import { formatErrorLogForCopy, truncateForSnackbar } from '@/utils/appErrorLog';


const __default__ = { name: 'AppGlobalNotify' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const SNACK_SINGLE = 200;
const SNACK_LAST_IN_MULTI = 100;

const count = computed(() => appNotifyState.items.length);

const snackbarBody = computed(() => {
  const n = count.value;
  const last = appNotifyState.items[n - 1]?.message ?? '';
  if (n <= 1) {
    return truncateForSnackbar(last, SNACK_SINGLE);
  }
  return `Ошибок: ${n}. Последняя: ${truncateForSnackbar(last, SNACK_LAST_IN_MULTI)}`;
});

function formatTime(at: number): string {
  return new Date(at).toLocaleString();
}

async function copyLast(): Promise<void> {
  const last = appNotifyState.items[appNotifyState.items.length - 1]?.message;
  if (last) {
    await Clipboard.copy(last);
  }
}

async function copyAll(): Promise<void> {
  if (count.value === 0) {
    return;
  }
  await Clipboard.copy(formatErrorLogForCopy(appNotifyState.items));
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_snackbar, {
      modelValue: _unref(appNotifyState).snackbarVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(appNotifyState).snackbarVisible) = $event)),
      timeout: -1,
      location: "bottom",
      color: "error",
      "multi-line": "",
      "max-width": "560"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          size: "small",
          onClick: copyLast
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Копировать", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          variant: "text",
          size: "small",
          onClick: _unref(openErrorLog)
        }, {
          default: _withCtx(() => [
            _createTextVNode("Все (" + _toDisplayString(count.value) + ")", 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_btn, {
          icon: "mdi-close",
          variant: "text",
          size: "small",
          "aria-label": "Закрыть",
          onClick: _unref(dismissErrorSnackbar)
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(snackbarBody.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(appNotifyState).logDialogOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(appNotifyState).logDialogOpen) = $event)),
      "max-width": "960",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, "Все ошибки (" + _toDisplayString(count.value) + ")", 1),
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  "aria-label": "Закрыть",
                  onClick: _unref(closeErrorLog)
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "pa-0" }, {
              default: _withCtx(() => [
                (count.value > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(appNotifyState).items, (it, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: it.id,
                        class: "error-log-entry px-4 py-3"
                      }, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(idx + 1) + ". " + _toDisplayString(formatTime(it.at)), 1),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(it.message), 1)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, "Список пуст"))
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "tonal",
                  disabled: count.value === 0,
                  onClick: copyAll
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("Копировать всё", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  disabled: count.value === 0,
                  onClick: _unref(clearErrorLog)
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("Очистить", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _unref(closeErrorLog)
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("Закрыть", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})